var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-deadline-form',{attrs:{"next-step-path":"PartnerPortal-ReportDamage-Counterparty","previous-step-path":"PartnerPortal-ReportDamage-DocumentUpload","is-broker":true}})}
var staticRenderFns = []

export { render, staticRenderFns }